

function ExpireBountyIcon() {
    return (
       <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
<path d="M6.5 0C4 0 2 2 2 4.5V5C0.89 5 0 5.89 0 7V16C0 17.11 0.89 18 2 18H6.72C8.18 19.29 10.06 20 12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C11.66 4 11.32 4.03 11 4.08C10.76 1.77 8.82 0 6.5 0ZM6.5 2C7.16304 2 7.79893 2.26339 8.26777 2.73223C8.73661 3.20107 9 3.83696 9 4.5V5H4V4.5C4 3.83696 4.26339 3.20107 4.73223 2.73223C5.20107 2.26339 5.83696 2 6.5 2ZM12 6C13.5913 6 15.1174 6.63214 16.2426 7.75736C17.3679 8.88258 18 10.4087 18 12C18 13.5913 17.3679 15.1174 16.2426 16.2426C15.1174 17.3679 13.5913 18 12 18C10.4087 18 8.88258 17.3679 7.75736 16.2426C6.63214 15.1174 6 13.5913 6 12C6 10.4087 6.63214 8.88258 7.75736 7.75736C8.88258 6.63214 10.4087 6 12 6ZM11 8V13L14.64 15.19L15.42 13.9L12.5 12.15V8H11Z" fill="#5E5E5E"/>
</svg>
    );
}

export default ExpireBountyIcon;
